import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../../../hooks/withRouter";
import { updateUserSettings } from "../../../../api";
import "./ticker.scss";

class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.wrapperRef = React.createRef();
  }

  handleOutsideClick = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ visible: false });
    }
  };

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleOutsideClick);
    let theme = localStorage.getItem("theme");
    if (theme === null) {
      if (localStorage.getItem("user") !== null) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.setState(
          {
            theme: user.settings && user.settings.darkUIMode ? "dark" : "light",
          },
          () => {
            document.documentElement.setAttribute(
              "data-theme",
              this.state.theme
            );
          }
        );
      }
    } else {
      document.documentElement.setAttribute("data-theme", theme);
      this.setState({
        theme: theme,
      });
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  closeDropdown() {
    this.setState({ visible: false });
  }

  switchTheme = () => {
    var setTo = this.state.theme === "light" ? "dark" : "light";
    this.setState(
      {
        theme: setTo,
      },
      () => {
        updateUserSettings({
          darkUIMode: this.state.theme === "dark",
        });
      }
    );
    document.documentElement.setAttribute("data-theme", setTo);
    localStorage.setItem("theme", setTo);
  };

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  clearSession = () => {
    localStorage.clear();
    this.props.navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  render() {
    let user = localStorage.getItem("user");
    return (
      <li className="nav-item dropdown" ref={this.wrapperRef} style={{ listStyle: "none" }}>
        {user !== null && (
          <button
            className="nav-link text-nowrap px-3 btn btn-link"
            onClick={this.toggleUserActions}
            style={{ background: "none", border: "none" }}
          >
            <img
              className="user-avatar rounded-circle mr-2"
              src={
                user !== null && JSON.parse(user).avatar !== undefined
                  ? JSON.parse(user).avatar.small
                  : require("./../../../../images/avatars/0.jpg")
              }
              alt="User Avatar"
            />
            {user !== null && (
              <span className="d-none d-md-inline-block">
                {JSON.parse(user).name}
              </span>
            )}
          </button>
        )}
        {user == null && (
          <Link
            style={{ top: window.screen.width > 767 ? 0 : {} }}
            id="btn-login"
            to="/login"
          >
            Login
          </Link>
        )}
        {user == null && (
          <Link
            style={{ top: window.screen.width > 767 ? 0 : {} }}
            id="btn-register"
            to="/register"
          >
            Register
          </Link>
        )}
        {user !== null && (
          <div
            className={`dropdown-menu dropdown-menu-right${
              this.state.visible ? " show" : ""
            }`}
          >
            <Link className="dropdown-item" to="/user-profile" onClick={this.closeDropdown}>
              <i className="material-icons">&#xE7FD;</i> Profile
            </Link>
            <Link
              className="dropdown-item text-danger"
              to="/"
              onClick={() => { this.closeDropdown(); this.clearSession(); }}
            >
              <i className="material-icons text-danger">&#xE879;</i> Logout
            </Link>
            <div className="dropdown-divider" />
            <div className="darkTheme">
              <div
                className="dropdown-item"
                style={{ display: "flex", alignItems: "center", gap: "0.6rem", cursor: "pointer" }}
                onClick={() => { this.switchTheme(); this.closeDropdown(); }}
              >
                {/* Inline mini toggle — fully self-contained, no absolute positioning */}
                <div style={{
                  position: "relative",
                  width: "34px",
                  height: "18px",
                  flexShrink: 0,
                }}>
                  <div style={{
                    width: "34px",
                    height: "18px",
                    borderRadius: "9px",
                    background: this.state.theme === "dark" ? "#17c671" : "#e1e5eb",
                    transition: "background 300ms",
                  }} />
                  <div style={{
                    position: "absolute",
                    top: "2px",
                    left: this.state.theme === "dark" ? "18px" : "2px",
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    background: "#fff",
                    transition: "left 300ms",
                  }} />
                </div>
                <span style={{ fontSize: "14px", userSelect: "none" }}>Dark Mode</span>
              </div>
            </div>
          </div>
        )}
      </li>
    );
  }
}

export default withRouter(UserActions);
